import React from 'react'
import SEO from '../components/SEO'
import Layout from '../components/layout'
import '../styles/uses.scss'

function index() {
  return (
    <Layout>
      <SEO title="Uses" description="A page dedicated to the language/framework/tools and other stuff I use daily" />

      <h1 className="uses-header">Things I use to get stuff done</h1>

      <main className="uses">
       
        <section className="uses-section">
          <h2>Big Data Stack</h2>
          <li>
            <span className="uses-subheader">Distributed Computing Frameworks -</span> Apache Spark , Apache HIVE , Map Reduce
          </li>
          <li>
            <span className="uses-subheader"> AWS Big Data Services  -</span> EMR ,Athena, Data Pipeline, Redshift, Kinesis , Networking (VPC ) , CloudWatch , CloudTrail ,
Lambda ,S3 , IAM
          </li>
          <li>
            <span className="uses-subheader">DataWarehouse & MPP -</span> Redshift , Presto on EMR 
          </li>
          <li>
            <span className="uses-subheader">DataFormats -</span> Parquet , Avro , JSON , CSV
          </li>
          <li>
            <span className="uses-subheader">ETL/ELT tools -</span> AWS Data Pipeline, AWS Glue
          </li>
          <li>
            <span className="uses-subheader">HBase -</span> Highly available and scalable but a pain to setup.
          </li>
        </section>

       
        <section className="uses-section">
          <h2>Full Stack Development</h2>
          <li>
            <span className="uses-subheader">React -</span> Love it
          </li>
          <li>
            <span className="uses-subheader">Flask -</span> I believe its more conveniet to make micro services APIs with Flask while I personally find a tad bit difficult to work with django's batteries included philosophy.
          </li>
          <li>
            <span className="uses-subheader">Spring -</span> Lately having my fair share of time working with Java Enterprise Solutions
          </li>
          <li>
            <span className="uses-subheader">Postgres -</span> Probably the most user friendly database.
          </li>
          <li>
            <span className="uses-subheader">DynamoDb-</span>I always advice customer to think of DDB as a partitioned B-tree data structure.If you can model your use case as such then DynamoDB is a viable choice for your needs.
          </li>
         
        </section>
        <section className="uses-section">
          <h2>Language</h2>
          <li>
            <span className="uses-subheader">Java -</span> For competitive Programming
          </li>
          <li>
            <span className="uses-subheader">Javascript -</span> Getting myself better on this and learning new stuff !
          </li>
          <li>
            <span className="uses-subheader">Python -</span> Who doesn't like 🐍
          </li>
          <li>
            <span className="uses-subheader">Bash -</span> Either you love it or hate, guess which side I'm on
          </li>
          <li>
            <span className="uses-subheader">SQL -</span> I love that there are no layers. It's just data and you
          </li>

        </section>
        <section className="uses-section">
          <h2>Tools & Certifications </h2>
          <li>
            <span className="uses-subheader">AWS ASA -</span> Certified Assosciate Solution Architect
          </li>
          <li>
            <span className="uses-subheader">VSCode -</span> The best editor out there
          </li>
          <li>
            <span className="uses-subheader">HUE editor for HiveQL -</span> Its not perfect but does a pretty decent job.
          </li>
          <li>
            <span className="uses-subheader">DBeaver -</span> My favourite JDBC tool
          </li>
        </section>
       
        
      </main>
    </Layout>
  )
}

export default index
